// extracted by mini-css-extract-plugin
export var bp = "'../../theme/breakpoints.module.css'";
export var medium = "800px";
export var xmedium = "640px";
export var small = "480px";
export var xsmall = "320px";
export var palette = "'../../theme/palette.module.css'";
export var accent = "#3D5CFF";
export var button = "style-module--button--323Nb";